module.exports = __webpack_public_path__ + "static/AvenirNext-Bold-4d2b452a17c1d7797800c66f1ae61d5e.woff2";